import { useContext } from "react";
import { userDataContext } from "@/hooks/useUserData";
import { isReadOnlyUser } from "@/utils/permissions";

/**
 * 現在のユーザーが読み取り専用アカウントかどうかを判定するフックです。
 * @returns 読み取り専用の場合は`true`、それ以外は`false`を返します。
 */
export const useReadOnlyUser = (): boolean => {
  const userData = useContext(userDataContext);
  return isReadOnlyUser(userData.data);
};
